import { CbwsRequest } from "../types";

const CbwsRequestDefaults: CbwsRequest = {
  atcPercentageRouting: null,
  bothWays: null,
  carrier1Criteria: "***",
  carrier2Criteria: "***",
  carrier3Criteria: null,
  destinationCriteria: "***",
  destinationCriteriaLocationType: "A",
  enableOnline: false,
  interAirportConnections: false,
  logicalPathOnly: null,
  lowCostConnectionsIndicator: null,
  maxCT1: 400,
  maxCT2: null,
  maxCircuity: 180,
  maxDoublesRoute: null,
  maxElapsedTime: 2400,
  maxSinglesRoute: null,
  originCriteria: null,
  originCriteriaLocationType: "A",
  overrideMinCT1: null,
  overrideMinCT2: null,
  requestDate: null,
  requestDateEffectiveFrom: null,
  requestDateEffectiveTo: null,
  requestTime: "00:00:01",
  rtnRequestDate: null,
  rtnRequestTime: null,
  sortOrder: "D",
  useForwardRoutes: null,
  via1Criteria: "***",
  via1CriteriaLocationType: "A",
  via2Criteria: "", //populate for double connections
  via2CriteriaLocationType: "A",
  preferredCarrierCriteria: null,
  excludeCarrierCriteria: null,
  mcConnectionsIndicator: null,
  transportTypeIndicator: null,
  operatingCarrierOnly: false,
  nonOperatingCarrierOnly: null,
  mctProductOverrideId: null,
  extraLocationFilter: null,
  includeFreighter: null,
  includeRoadFeederService: null,
  wideToNarrowIndicator: null,
  cargoCarrierDupePriority: null,
  backHaulIndicator: null,
  leg1ServiceNumber: null,
  leg2ServiceNumber: null,
  leg3ServiceNumber: null,
  conciseFormatForConxAlerts: null,
  maxSingleCnxPerRoute: null,
  maxDoubleCnxPerRoute: null,
  notEditable: null,
  equipmentType: null,
  equipmentCategoryCode: null,
  dbWrite: null,
  overrideMinCT1DDDIIDII: null,
  overrideMinCT2DDDIIDII: null,
  overrideMaxCT1DDDIIDII: null,
  overrideMaxCT2DDDIIDII: null,
  applyPhantomFlights: null,
  interlineType: null,
  specificPhantomFlightIds: null,
  userId: null,
  numberOfStops: null,
  stopsLtGtEq: null,
  missedCnxMCTTolerance: null,
  missedCnxMaxCTTolerance: null,
  checkMissedConnections: null,
  applyQSI: null,
  allowRestrictedFlights: null,
  internationalOrDomestic: null,
  multiConnectionRequest: null,
  timeSeries: null,
  periodType: null,
  includeRoutes: true,
  includeResults: true,
  includeMarkers: true,
  requestType: null,
  language: "EN",
  description: "",
  includeCodeShare: true,
  nonStopDirect: false,
  dateFormat: null,
  timeFormat: null,
  configurationKey: null,
  maxResults: null,
};

export default CbwsRequestDefaults;
